import type { Menu } from '@frontend/libs/types/site-configuration'

import { Link } from 'react-router-dom'

function MenuList({ items, title }: Readonly<Menu>) {
  return (
    <>
      <h4 className="mb-4 font-medium uppercase text-primary">{title}</h4>
      {items?.length === 0 && <></>}
      {items?.length > 0 && (
        <ul className="list-none">
          {items.map((item) => (
            <li className="my-2" key={item.id}>
              <Link
                className="uppercase text-primary md:text-sm"
                target={item.target}
                title={item.title}
                to={item.url}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}

export default MenuList
